import axiosInstance from "./axios.instance";

class ApiClient {
  async get(path: string, params: any | null = null, headers = {}) {
    const response = await axiosInstance.get(path, {
      params,
      headers,
    });
    return response.data;
  }

  async post(path: string, payload: any, headers = {}) {
    const response = await axiosInstance.post(path, payload, {
      headers,
    });
    return response.data;
  }

  async delete(path: string, params: any) {
    const response = await axiosInstance.delete(path, {
      params,
    });
    return response.data;
  }

  async patch(path: any, payload: any = {}) {
    const response = await axiosInstance.patch(path, payload);
    return response.data;
  }

  async put(path: any, payload: any) {
    const response = await axiosInstance.put(path, payload);
    return response.data;
  }
}

export const ApiRequestClient = new ApiClient();
